import type { AppsSource } from '../types'

type Subscriber<T> = (vm: T) => void

export default abstract class Presenter<T> {
  protected subscriber: Subscriber<T> | undefined

  constructor(public vm: T) {}

  abstract displayMessage(msg: string): void

  protected notifyVM() {
    this.subscriber?.call(this.subscriber, this.vm)
  }

  protected diffVM(vmValue: unknown, newValue: unknown) {
    if (vmValue !== newValue) {
      return true
    }

    return false
  }

  //TODO: to test
  protected setVM(vmValue: unknown, newValue: unknown) {
    if (this.diffVM(vmValue, newValue)) {
      vmValue = newValue
      this.notifyVM()
    }
  }

  subscribeVM(subscriber: Subscriber<T>) {
    this.subscriber = subscriber
    this.subscriber(this.vm)
  }
}

type DisplayVM<
  Input = unknown,
  Output = unknown,
  Params extends unknown[] = unknown[],
> = (input: Input, ...args: Params) => Output

export type AppsAdapter = Record<AppsSource, unknown>
export class NotImplementedError extends Error {
  constructor() {
    super('Not implemented')
  }
}

export abstract class PolymorphicAdapter<
  Model,
  ViewModelReturnTypes extends AppsAdapter,
  AppSource extends AppsSource = 'web',
> {
  constructor(protected source: AppsSource = 'web') {}

  protected displayMobile(
    ..._: Parameters<DisplayVM<Model, ViewModelReturnTypes['mobile']>>
  ) {
    throw new NotImplementedError()
  }

  protected displayStay(
    ..._: Parameters<DisplayVM<Model, ViewModelReturnTypes['stay']>>
  ) {
    throw new NotImplementedError()
  }

  protected displayWeb(
    ..._: Parameters<DisplayVM<Model, ViewModelReturnTypes['web']>>
  ) {
    throw new NotImplementedError()
  }

  display(model: Model, ...params: unknown[]): ViewModelReturnTypes[AppSource] {
    switch (this.source) {
      case 'mobile':
        return this.displayMobile(model, ...params)
      case 'stay':
        return this.displayStay(model, ...params)
      case 'web':
      default:
        return this.displayWeb(model, ...params)
    }
  }
}
